var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-head"},[_vm._t("default"),_c('div',{ref:"line",staticClass:"line"}),_c('div',{staticClass:"action-wrapper"},[_vm._t("action")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }